import { useQuery } from '@tanstack/react-query'

import { billingApi } from '@/lib/api/billing'
import { queryKeys } from '@/lib/queryClient'

/**
 * The signed-in account's credit balance.
 *
 * The server decides whether credits are a thing in this deployment: `billing_enabled` on
 * the response is the switch, and every piece of credit interface is hidden when it is
 * false. That keeps the decision in one place — a build-time flag here would let the browser
 * disagree with the server about whether a user is being charged.
 *
 * Not retried, and failing quietly: a balance is ambient information in the page header, and
 * a server that cannot report it must not put an error card over someone's conversation.
 */
export function useCredits() {
  const query = useQuery({
    queryKey: queryKeys.credits,
    queryFn: () => billingApi.balance(),
    staleTime: 30_000,
    retry: false,
  })

  return {
    ...query,
    /** Whether to render credit interface at all. */
    enabled: query.data?.billing_enabled === true,
  }
}
